import styled from "styled-components";

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;
export const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  width: 100%;
  justify-content: space-between;
  @media (max-width: 375px) {
    gap: 4px;
  }
`;
export const VideoHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  position: absolute;
  left: 16px;
  right: 16px;
  top: 16px;
  z-index: 2;
  @media (max-width: 375px) {
    gap: 4px;
    left: 8px;
    right: 8px;
    top: 8px;
  }
`;

export const ImageElement = styled.img`
  width: 100%;
  height: 100%;
  object-fit: ${(props) => (props.$isVerticalImage ? "cover" : "contain")};
  transition: opacity 0.3s ease;
  border-radius: 12px;

  @media (max-width: 768px) {
    border-radius: 8px;
  }
`;

export const VideoElement = styled.video`
  border-radius: 12px;
  height: 100%;
  width: 100%;
  opacity: ${(props) => (props.$loaded ? "1" : "0")};
  transition: opacity 0.3s ease;
  object-fit: ${(props) => (props.$isVerticalImage ? "cover" : "contain")};

  @media (max-width: 768px) {
    border-radius: 8px;
  }
`;

export const ModalContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background: #0a1424;
  border: 1px solid #142743;
  border-radius: 12px;
  overflow: visible;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);

  aspect-ratio: ${(p) => p.$aspectRatio};

  width: auto;

  min-height: ${(p) => p.$minHeight};
  min-width: 360px;
  max-width: min(90dvw, 720px);
  max-height: 90dvh;

  height: min(90dvh, 720px);

  @media (max-width: 475px) {
    min-width: 320px;
    max-height: 85dvh;
    width: 90dvw;
    height: auto;
  }
  @media (max-width: 330px) {
    min-width: 100%;
  }
`;

export const ModalContent = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const ModalTitle = styled.h2`
  color: #fff;
  font-family: Figtree;

  font-size: 15px;

  font-weight: 400;
  line-height: 20px; /* 133.333% */
  opacity: 0.5;
`;

export const Row = styled.div`
  display: flex;

  flex-direction: row;
  align-items: center;
  margin-bottom: 15px;
  gap: 10px;
`;

export const NoticeList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const NoticeText = styled.span`
  color: #fff;
  font-family: Figtree;

  font-size: 15px;
  font-weight: 400;
  line-height: 20px; /* 133.333% */
  opacity: ${(props) => (props.$light ? 0.4 : 1)};
`;
export const NoticeItem = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: column;
`;

export const FooterText = styled.p`
  font-size: 14px;
  line-height: 1.6;
  margin: 8px 0 0 0;
  color: ${({ theme }) =>
    theme === "light" ? "rgba(0, 0, 0, 0.7)" : "rgba(255, 255, 255, 0.8)"};
  text-align: center;
`;

export const LinkText = styled.span`
  color: #2877d9;
  cursor: pointer;
  text-decoration: underline;
  transition: color 0.3s ease;

  &:hover {
    color: #38f9d7;
  }
`;

export const ContinueButton = styled.button`
  display: flex;
  padding: 8px 44px 8px 32px;
  justify-content: center;
  width: fit-content;
  align-items: center;
  align-self: center;
  gap: 10px;
  cursor: pointer;
  border-radius: 100px;
  background: #fff;

  color: #081120;
  font-family: Figtree;

  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;

  transition: all 0.3s ease;
  margin-top: 8px;

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;

  &:hover {
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const ModalText = styled.span`
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
  color: ${({ theme }) =>
    theme === "light" ? "rgba(0, 0, 0, 0.7)" : "rgba(255, 255, 255, 0.8)"};
`;

// export const Button = styled.button`
//   border-radius: 100px;
//   background: rgba(0, 0, 0, 0.5);
//   border: none;
//   outline: none;
//   cursor: pointer;
//   transition: all 0.3s ease;

//   color: #fff;
//   font-family: Figtree;
//   font-size: 14px;
//   font-weight: 400;
//   letter-spacing: -0.07px;

//   display: flex;
//   white-space: nowrap;
//   padding: 10px;
//   justify-content: center;
//   align-items: center;
//   gap: 4px;
//   flex-direction: row;

//   &:hover:not(:disabled) {
//     background: rgba(0, 0, 0, 0.7);
//     transform: translateY(-1px);
//   }

//   &:disabled {
//     opacity: 0.5;
//     cursor: not-allowed;
//   }

//   @media (max-width: 370px) {
//     width: 100%;
//   }
// `;

export const ButtonText = styled.div`
  font-family: Figtree;
  font-size: 14px;
  font-weight: 600;
  z-index: 2;
  color: #fff;
`;

export const Button = styled.div`
  display: flex;
  max-width: ${(p) => (p.$maxWidth ? p.$maxWidth : "100%")};

  height: 42px;
  width: 100%;
  flex: 1;
  padding: 0 8px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  outline: none;
  border: none;
  gap: 4px;
  position: relative;
  border-radius: 1000px;
  background: none;
  z-index: 100;
  overflow: hidden;
  isolation: isolate;
  box-shadow: inset 0 0.5px 0 rgba(255, 255, 255, 0.1);

  &::before {
    content: "";
    position: absolute;
    inset: 0px;
    border-radius: inherit;
    border: 0.5px solid rgb(255 255 255 / 15%);
    background:
      linear-gradient(
        rgba(255, 255, 255, 0.09) 0%,
        rgba(255, 255, 255, 0.03) 22%,
        rgba(0, 0, 0, 0.12) 100%
      ),
      rgba(7, 7, 9, 0.05);
    backdrop-filter: blur(36px) saturate(200%) brightness(0.77);
    -webkit-backdrop-filter: blur(36px) saturate(200%) brightness(0.77);
    z-index: 0;
    pointer-events: none;
    transform: translateZ(0px);
    backface-visibility: hidden;
    box-shadow:
      rgba(255, 255, 255, 0.14) 0px 1px 12px inset,
      rgba(255, 255, 255, 0.04) 0px -1px 0px inset;
  }
  transition: all 0.3s ease;
  svg {
    z-index: 2;
  }

  @media (max-width: 768px) {
    padding: 0;
  }
  @media (max-width: 340px) {
    min-width: 163px;
  }
  &:hover:not(:disabled) {
    transform: translateY(-1px);
  }
`;
export const StyledButton2 = styled.button`
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  outline: none;
  cursor: pointer;

  min-height: 40px;
  max-height: 40px;
  min-width: 40px;
  max-width: 40px;

  z-index: 3;
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.07px;
  position: relative;
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-direction: row;
  background: none;
  z-index: 100;
  /* overflow: hidden; */
  isolation: isolate;
  box-shadow: inset 0 0.5px 0 rgba(255, 255, 255, 0.1);

  &::before {
    content: "";
    position: absolute;
    inset: 0px;
    border-radius: inherit;
    border: 0.5px solid rgb(255 255 255 / 15%);
    background:
      linear-gradient(
        rgba(255, 255, 255, 0.09) 0%,
        rgba(255, 255, 255, 0.03) 22%,
        rgba(0, 0, 0, 0.12) 100%
      ),
      rgba(7, 7, 9, 0.05);
    backdrop-filter: blur(36px) saturate(200%) brightness(0.77);
    -webkit-backdrop-filter: blur(36px) saturate(200%) brightness(0.77);
    z-index: 0;
    pointer-events: none;
    transform: translateZ(0px);
    backface-visibility: hidden;
    box-shadow:
      rgba(255, 255, 255, 0.14) 0px 1px 12px inset,
      rgba(255, 255, 255, 0.04) 0px -1px 0px inset;
  }

  svg {
    z-index: 102;
  }

  &:hover:not(:disabled) {
    transform: translateY(-1px);
  }
`;

export const FavoriteButton = styled(StyledButton2)``;

export const MessageButton = styled(StyledButton2)`
  background: ${(p) =>
    p.$ratingUp
      ? "rgba(40, 217, 96, 0.25)"
      : p.$ratingDown
        ? "rgba(255, 89, 89, 0.25)"
        : " linear-gradient(180deg,rgba(255, 255, 255, 0.09) 0%, rgba(255, 255, 255, 0.03) 22%, rgba(0, 0, 0, 0.22) 100%), rgba(7, 7, 9, 0.23)"};

  &:hover:not(:disabled) {
    background: ${(p) =>
      p.$ratingUp
        ? "rgba(40, 217, 96, 0.35)"
        : p.$ratingDown
          ? "rgba(255, 89, 89, 0.35)"
          : " linear-gradient(180deg,rgba(255, 255, 255, 0.09) 0%, rgba(255, 255, 255, 0.03) 22%, rgba(0, 0, 0, 0.22) 100%), rgba(7, 7, 9, 0.23)"};

    transform: translateY(-1px);
  }
`;

export const SettingsButton = styled(StyledButton2)``;

export const ButtonsRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  gap: 6px;
  align-items: flex-end;
  @media (max-width: 475px) {
    gap: 4px;
  }
`;

export const ButtonsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  @media (max-width: 475px) {
    gap: 4px;
  }
`;

export const FolderButton = styled(StyledButton2)``;

export const ArrowButton = styled(StyledButton2)``;
export const ArrowButtonWrapper = styled.div`
  position: absolute;
  z-index: 3005;
  left: ${(p) => (p.$right ? "unset" : "-100px")};
  right: ${(p) => (!p.$right ? "unset" : "-100px")};
  top: 50%;
  transform: translateY(-50%);
  @media (max-width: 768px) {
    left: ${(p) => (p.$right ? "unset" : "0")};
    right: ${(p) => (!p.$right ? "unset" : "0")};
    transform: none;
    bottom: -48px;
    top: unset;
  }
`;

export const DownloadButton = styled(StyledButton2)``;

export const MuteButton = styled(StyledButton2)``;

export const DeleteButton = styled(StyledButton2)``;

export const Tooltip = styled.div`
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  padding: 8px 12px;
  background: rgba(0, 0, 0, 0.9);
  color: white;
  font-size: 14px;
  font-family: Figtree;
  border-radius: 6px;
  white-space: nowrap;
  pointer-events: none;
  z-index: 1000;

  /* Arrow */
  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    border-top-color: rgba(0, 0, 0, 0.9);
  }

  /* Animation */
  animation: fadeIn 0.2s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateX(-50%) translateY(-4px);
    }
    to {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
  }
`;
export const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;

  @media (max-width: 415px) {
    gap: 4px;
  }
  @media (max-width: 340px) {
    flex-wrap: wrap;
  }
`;

export const CloseButton = styled(StyledButton2)`
  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 5;
  max-width: 32px;
  max-height: 32px;
  min-width: 32px;
  min-height: 32px;
  padding: 0;
  svg {
    width: 20px;
    height: 20px;
  }
`;
export const VideoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
`;

export const ThumbnailVideo = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: ${(props) => (props.$loaded ? "0" : "1")};
  visibility: ${(props) => (props.$loaded ? "hidden" : "visible")};
  filter: ${(props) => (props.$blur ? "blur(8px)" : "none")};
  transform: ${(props) => (props.$blur ? "scale(1.1)" : "scale(1)")};
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 12px;
  object-fit: contain;
`;
export const LoadingSpinnerVideo = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;

export const VideoFooter = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  /* pointer-events: none; */
  color: white;
  /* background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 61.05%,
    rgba(0, 0, 0, 0.64) 100%
  ); */
  display: flex;
  flex-direction: column;
  z-index: 2;

  justify-content: flex-end;
  gap: 12px;
  transition: all 0.3s ease-in-out;

  padding: 16px;
  @media (max-width: 375px) {
    padding: 8px;
  }
`;

export const ModelName = styled.div`
  color: #fff;
  font-family: Figtree;
  font-size: 18px;
  font-weight: 600;
  white-space: nowrap;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ModelSeed = styled.div`
  color: #fff;
  font-family: Figtree;
  width: fit-content;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.07px;

  display: flex;
  padding: 3px 8px;
  align-items: center;
  gap: 4px;
  border-radius: 100px;
  background: rgba(24, 24, 27, 0.18);
  z-index: 3;
`;

export const Date = styled.div`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.07px;
  white-space: nowrap;
  opacity: 0.5;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;
